import React from 'react';
import * as conciliationRequestAdminService from '../../../services/conciliation/admin/Conciliation';
const ConciliationRequestAdminContext = React.createContext();
const { Provider, Consumer } = ConciliationRequestAdminContext;

class ConciliationRequestAdminProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.home = this.home.bind(this);
    this.exportConciliationRequests = this.exportConciliationRequests.bind(
      this,
    );
    this.editConciliationRequest = this.editConciliationRequest.bind(this);
    this.updateConciliationRequest = this.updateConciliationRequest.bind(this);
    this.deleteConciliationRequest = this.deleteConciliationRequest.bind(this);
    this.assessment = this.assessment.bind(this);
    this.postpone = this.postpone.bind(this);
    this.approval = this.approval.bind(this);
    this.publishResults = this.publishResults.bind(this);
  }

  async home(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .home(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async exportConciliationRequests(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .exportConciliationRequests(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async editConciliationRequest(id) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .editConciliationRequest(id)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async updateConciliationRequest(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .updateConciliationRequest(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async assessment(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .assessment(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async postpone(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .postpone(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async approval(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .approval(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async publishResults(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .publishResults(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async deleteConciliationRequest(data) {
    return new Promise(async (resolve, reject) => {
      await conciliationRequestAdminService
        .deleteConciliationRequest(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          home: this.home,
          exportConciliationRequests: this.exportConciliationRequests,
          editConciliationRequest: this.editConciliationRequest,
          updateConciliationRequest: this.updateConciliationRequest,
          deleteConciliationRequest: this.deleteConciliationRequest,
          assessment: this.assessment,
          postpone: this.postpone,
          approval: this.approval,
          publishResults: this.publishResults,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default ConciliationRequestAdminContext;

export { ConciliationRequestAdminProvider, Consumer };
